import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'magazine',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/MagazinePageContainer'),
  }),
};
